import { render } from "./ToDoForm.vue?vue&type=template&id=383fcd9c"
import script from "./ToDoForm.vue?vue&type=script&lang=js"
export * from "./ToDoForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/derbyweb.dev/todo.derbyweb.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__